import useSite from '../hooks/useSite';
import CarouselBuildingViews from '../components/CarouselBuildingViews';
import NavBar from './NavBar';

import { Disclaimer } from '../components/Disclaimer';
import { IframeViewerModal } from '../components/IframeViewerModal';
import { modalIsOpenAtom, showMapsViewAtom, showPanoramaViewAtom, showSolarsViewAtom } from '../states/planner';
import { useAtom } from 'jotai';
import { FullscreenModal } from '../components/FullscreenModal';
import { PanoramaViewer } from '../components/PanoramaViewer';
import { MapViewer } from '../components/MapViewer';
import { SolarViewer } from '../components/SolarViewer';
import { TableApartments } from '../components/TableApartments';

const Planner = ({ maxTableHeight, maxWidth }: { maxTableHeight?: string; maxWidth?: string }) => {
  const [site] = useSite();
  const [modalIsOpen] = useAtom(modalIsOpenAtom);

  if (!site?.siteid) {
    return <></>;
  }

  if (site.disabled && process.env.NODE_ENV !== 'development') {
    return <></>;
  }

  return (
    <div
      id="pintar-planner-wrapper"
      part="pintar-planner-wrapper"
      className={`m-auto`}
      style={{ maxWidth: maxWidth ? `${maxWidth}` : '64rem' }}
    >
      <NavBar />

      <div className={`pintar-planner-content-wrapper relative ${modalIsOpen ? 'hidden' : ''}`}>
        <CarouselBuildingViews />
        <TableApartments maxTableHeight={maxTableHeight} />
        <Disclaimer />
      </div>

      <div id="modals">
        <FullscreenModal isOpenAtom={showMapsViewAtom} pathSegment="map" className="relative max-w-5xl">
          <MapViewer />
        </FullscreenModal>
        <FullscreenModal isOpenAtom={showPanoramaViewAtom} pathSegment="panorama">
          <PanoramaViewer fullscreen />
        </FullscreenModal>
        <FullscreenModal isOpenAtom={showSolarsViewAtom} pathSegment="solar" className="relative max-w-5xl">
          <SolarViewer />
        </FullscreenModal>

        <IframeViewerModal />
      </div>
    </div>
  );
};

export default Planner;
